import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import CommentPost from '../components/CommentPost';
import DiscussionPost from '../components/DiscussionPost';
import FlarumCommentPost from 'flarum/forum/components/CommentPost';

export default () => {
  extend(FlarumCommentPost.prototype, 'oninit', function () {
    this.subscription = undefined;
    this.cardVisible = false;

    this.updateSubscriptionState = () => this.subscription = this.attrs.post.discussion().subscription();
    this.setCardOpen = () => this.cardVisible = true;
    this.setCardClosed = () => this.cardVisible = false;

    this.reRouteLoggedOutUser = (e) => {
      if (app.session.user) return;

      e.stopPropagation();
      e.preventDefault();
      m.route.set(`/become-a-member?redirect=${m.route.get()}`);
    };

    this.subtree.check(
      () => this.subscription,
      () => this.cardVisible
    );
  });

  override(FlarumCommentPost.prototype, 'view', function (_, context) {
    const { post } = context.attrs;

    if (post.number() === 1) {
        return <DiscussionPost 
                 post={post} 
                 discussion={post.discussion()} 
                 onSubscriptionUpdate={this.updateSubscriptionState} 
                 setCardOpen={this.setCardOpen}
                 setCardClosed={this.setCardClosed}
                 reRouteLoggedOutUser={this.reRouteLoggedOutUser}
               />;
    }

    return <CommentPost 
              post={post} 
              togglePostLiked={togglePostLiked} 
              setCardOpen={this.setCardOpen}
              setCardClosed={this.setCardClosed}
              reRouteLoggedOutUser={this.reRouteLoggedOutUser}
            />;
  });
};

export async function togglePostLiked(post, isLiked) {
  if (!app.session.user) return;

  try {
    isLiked = !isLiked;

    // In order to provide instantaneous feedback to the user, 
    // we'll need to add or remove the like from the relationship data manually.
    const data = post.data.relationships.likes.data;
    data.some((like, i) => {
      if (like.id === app.session.user.id()) {
        data.splice(i, 1);
        return true;
      }
    });

    if (isLiked) {
      data.unshift({ type: 'users', id: app.session.user.id() });
    }

    await post.save({ isLiked });
  } catch (e) {
    console.error(e);
  } finally {
    m.redraw();
  }
};